import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { EmailTemplatesCrudSection } from '../../components/customerSuccess/EmailTemplatesCrudSection';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { LoadingSpinner } from '../../components/ui/LoadingSpinner';
import { usePermissions } from '../../contexts/PermissionsContext';
import { listModules, SystemModule } from '../../services/accessControlApi';

export function EmailTemplatesPage() {
  const { hasPermission } = usePermissions();
  const canWrite = hasPermission('settings.email-templates.write');
  const [modules, setModules] = useState<SystemModule[]>([]);
  const [loadingModules, setLoadingModules] = useState(true);

  useEffect(() => {
    void (async () => {
      setLoadingModules(true);
      try {
        const result = await listModules({ page: 1, pageSize: 500 });
        setModules(result.items.filter((item) => item.isActive));
      } catch {
        toast.error('Falha ao carregar módulos.');
      } finally {
        setLoadingModules(false);
      }
    })();
  }, []);

  return (
    <PageShell>
      <PageHeader
        title="Templates de e-mail"
        description="Biblioteca de e-mails reutilizáveis por módulo. Use macros para personalizar assunto e corpo."
      />
      {loadingModules ? (
        <LoadingSpinner label="Carregando módulos..." />
      ) : (
        <EmailTemplatesCrudSection
          scope="admin"
          canWrite={canWrite}
          showModulePicker
          moduleOptions={modules.map((module) => ({
            code: module.code,
            name: module.name,
          }))}
          createButtonLabel="Novo template"
        />
      )}
    </PageShell>
  );
}
